const Info = ({ ...props }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Icon / Info">
        <path
          id="Vector"
          d="M10 3.67188C13.4752 3.67188 16.3281 6.48657 16.3281 10C16.3281 13.4949 13.4978 16.3281 10 16.3281C6.50652 16.3281 3.67188 13.4992 3.67188 10C3.67188 6.50772 6.50201 3.67188 10 3.67188ZM10 2.73438C5.98759 2.73438 2.73438 5.98876 2.73438 10C2.73438 14.0136 5.98759 17.2656 10 17.2656C14.0124 17.2656 17.2656 14.0136 17.2656 10C17.2656 5.98876 14.0124 2.73438 10 2.73438ZM8.94531 12.8125H9.29688V9.29688H8.94531C8.75116 9.29688 8.59375 9.13946 8.59375 8.94531V8.71094C8.59375 8.51679 8.75116 8.35938 8.94531 8.35938H10.3516C10.5457 8.35938 10.7031 8.51679 10.7031 8.71094V12.8125H11.0547C11.2488 12.8125 11.4062 12.9699 11.4062 13.1641V13.3984C11.4062 13.5926 11.2488 13.75 11.0547 13.75H8.94531C8.75116 13.75 8.59375 13.5926 8.59375 13.3984V13.1641C8.59375 12.9699 8.75116 12.8125 8.94531 12.8125ZM10 5.78125C9.48224 5.78125 9.0625 6.20099 9.0625 6.71875C9.0625 7.23651 9.48224 7.65625 10 7.65625C10.5178 7.65625 10.9375 7.23651 10.9375 6.71875C10.9375 6.20099 10.5178 5.78125 10 5.78125Z"
          fill="#646464"
        />
      </g>
    </svg>
  )
}

export default Info
